import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.less';

/**
 * An avatar component that can show a badge.
 * Used in places like the sidebar, chat, and user profile.
 * @param {boolean} isActive
 * @param {boolean} showBadge
 * @param {React.ReactNode} Badge
 * @param {React.ReactNode} Image
 * @param {number} avatarSize
  // Avatar size in pixels
 * @param {number[]} badgePos
  // Badge position relative to the image.
  // [x, y] where x is the horizontal position and y is the vertical position.
  // x position starts at bottom
  // y position starts at right
 * @returns {React.ReactNode}
 */
const AvatarBase = ({
  isActive = false,
  Badge = null,
  Image = null,
  avatarSize = 22,
  badgePos = [-2, -2],
}) => (
  <div
    data-testid='avatar'
    className={classNames(styles.avatar, {
      [styles.showBadge]: !!Badge,
      [styles.active]: isActive,
    })}
    style={{
      '--badge-pos-x': `${badgePos[0]}px`, // position-bottom
      '--badge-pos-y': `${badgePos[1]}px`, // position-right
      '--avatar-size': `${avatarSize}px`,
    }}
  >
    <div className={styles.imageAndBadge}>
      <div className={styles.image}>{Image}</div>
      {Badge && <div className={styles.badge}>{Badge}</div>}
    </div>
  </div>
);

AvatarBase.propTypes = {
  isActive: PropTypes.bool,
  showBadge: PropTypes.bool,
  Image: PropTypes.node,
  avatarSize: PropTypes.number,
  Badge: PropTypes.node,
  badgePos: PropTypes.arrayOf(PropTypes.number),
};

export default AvatarBase;
